// import React,{useState,useEffect} from 'react'

// export const UpdateAggregationDetails = ({savedFarmers,handleNext}) => {
//     const [farmerInputs, setFarmerInputs] = useState({});
//   console.log("savedFarmers999999",savedFarmers)
// const handleInputChange = (id, field, value) => {
//   setFarmerInputs(prev => ({
//     ...prev,
//     [id]: {
//       ...prev[id],
//       [field]: value
//     }
//   }));
// };
// console.log("farmerInputs",farmerInputs)
//   return (
//     <div className='row'>
//         {Object.values(savedFarmers).map((farmer, index) => (
//   <div key={farmer.id} className="border rounded p-3 mb-3 shadow-sm col-lg-6">
//     <div className="d-flex align-items-start gap-3 mb-3">
//       <img src={farmer.profile_pic} alt="Farmer" style={{ width: 60, height: 60, borderRadius: '50%' }} />
//       <div>
//         <h6 className="mb-1">{farmer.full_name}</h6>
//         <p className="mb-0"><strong>Gender:</strong> {farmer.gender}</p>
//         <p className="mb-0"><strong>Age:</strong> {farmer.age}</p>
//         <p className="mb-0"><strong>Address:</strong> {farmer.address}, {farmer.district_name || ""}, {farmer.state_name || ""} - {farmer.pincode}</p>
//       </div>
//     </div>

//     <div className="row g-2">
//       <div className="col-md-4">
//         <label className="form-label">Quantity</label>
//         <input
//           type="number"
//           className="form-control"
//           name="quantity"
//           value={farmerInputs[farmer.id]?.quantity || ""}
//           onChange={(e) => handleInputChange(farmer.id, 'quantity', e.target.value)}
//         />
//       </div>
//       <div className="col-md-4">
//         <label className="form-label">Unit</label>
//         <select
//           className="form-select"
//           name="unit"
//           value={farmerInputs[farmer.id]?.unit || ""}
//           onChange={(e) => handleInputChange(farmer.id, 'unit', e.target.value)}
//         >
//           <option value="">Select Unit</option>
//           <option value="kg">Kg</option>
//           <option value="quintal">Quintal</option>
//           <option value="tonne">Tonne</option>
//         </select>
//       </div>
//       <div className="col-md-4">
//         <label className="form-label">Price (₹)</label>
//         <input
//           type="number"
//           className="form-control"
//           name="price"
//           value={farmerInputs[farmer.id]?.price || ""}
//           onChange={(e) => handleInputChange(farmer.id, 'price', e.target.value)}
//         />
//       </div>
//     </div>
//   </div>
// ))}

//     </div>
//   )
// }

import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useCreateAggregationFarmerStockMutation } from "./AggregationApiSlice";
import { Button } from "reactstrap";
export const UpdateAggregationDetails = ({
  savedFarmers = {},
  handleNext,
  setSelectedFarmers,
  aggregationDetails,
  setFarmerInputs,
  farmerInputs,
  handleBack,
}) => {
  //   const [farmerInputs, setFarmerInputs] = useState({});
  const [error, setError] = useState("");
  const [activeFarmers, setActiveFarmers] = useState(
    Object.values(savedFarmers)
  );
  console.log("savedFarmers", savedFarmers);
  const handleInputChange = (id, field, value, farmer) => {
    setFarmerInputs((prev) => {
      const existing = prev[id] || {};

      const updatedFarmerData = {
        farmer_id: farmer.id,
        farmer_name: farmer.full_name,
        farmer_mobile: farmer.phone_number,
        address: farmer.address,
        state_name: farmer.state_name ? farmer.state_name : "",
        state_id: farmer.state_id ? farmer.state_id : "",
        district_name: farmer.district_name ? farmer.district_name : "",
        district_id: farmer.district_id ? farmer.district_id : "",
        block_name: farmer.block_name ? farmer.block_name : "",
        block_id: farmer.block_id ? farmer.block_id : "",
        village_name: farmer.village_name ? farmer.village_name : "",
        village_id: farmer.village_id ? farmer.village_id : "",
        crop_name: aggregationDetails.crop_name,
        crop_id: aggregationDetails.crop_id,
        serial_no: 0,
        quantity: existing.quantity || "",
        unit_measurement: existing.unit_measurement || "", // ✅ match field
        quoted_price: existing.quoted_price || "", // ✅ match field
        quality_type: "",
        aggregation_id: aggregationDetails.id,
      };

      // Apply updated field
      updatedFarmerData[field] = value;

      return {
        ...prev,
        [id]: updatedFarmerData,
      };
    });
  };

  const handleRemoveFarmer = (id) => {
    let updatedSelection;
    // setActiveFarmers((prev) => prev.filter((f) => f.id !== id));
    // setFarmerInputs((prev) => {
    //   const updated = { ...prev };
    //   delete updated[id];
    //   return updated;
    // });
    // setSelectedFarmers((prevSelected) => {
    //   updatedSelection = { ...prevSelected };
    //   delete updatedSelection[id];
    //   return updatedSelection;
    // });
    // localStorage.setItem("selectedFarmers", JSON.stringify(updatedSelection));
  };
  console.log("farmerInputs", farmerInputs);
  const validateAndProceed = () => {
    const allValid = activeFarmers.every((farmer) => {
      const input = farmerInputs[farmer.id];
      return input?.quantity && input?.quoted_price && input?.unit_measurement;
    });
    if (!allValid) {
      setError(
        "Please fill quantity and price for all farmers before proceeding."
      );
      return;
    }
    setError("");
    handleNext();
  };

  return (
    //     <div className="">
    //       {error && <div className="alert alert-danger">{error}</div>}
    //       <div className="text-end">
    //         <button className="btn btn-primary" onClick={validateAndProceed}>
    //           Proceed
    //         </button>
    //       </div>
    //       <div className="row">
    //         {activeFarmers.map((farmer) => (
    //           <div key={farmer.id} className="col-lg-6">
    //             <div className="border rounded p-3 mb-4 shadow position-relative">
    //               <FontAwesomeIcon
    //                 icon={faTimesCircle}
    //                 size="lg"
    //                 className="position-absolute text-danger"
    //                 style={{ top: 12, right: 12, cursor: "pointer" }}
    //                 onClick={() => handleRemoveFarmer(farmer.id)}
    //               />
    //               <div className="d-flex align-items-start gap-3 mb-3">
    //                 <img
    //                   src={farmer.profile_pic}
    //                   alt="Farmer"
    //                   style={{ width: 60, height: 60, borderRadius: "50%" }}
    //                 />
    //                 <div>
    //                   <h6 className="mb-1">{farmer.full_name}</h6>
    //                   <p className="mb-0">
    //                     <strong>Gender:</strong> {farmer.gender}
    //                   </p>
    //                   <p className="mb-0">
    //                     <strong>Age:</strong> {farmer.age}
    //                   </p>
    //                   <p className="mb-0">
    //                     <strong>Address:</strong> {farmer.address},{" "}
    //                     {farmer.district_name || ""}, {farmer.state_name || ""} -{" "}
    //                     {farmer.pincode}
    //                   </p>
    //                 </div>
    //               </div>
    //               <div className="row g-2">
    //               <div className="col-md-4">
    //   <label className="form-label">Quantity</label>
    //   <input
    //     type="number"
    //     className="form-control"
    //     value={farmerInputs[farmer.id]?.quantity || ""}
    //     onChange={(e) =>
    //       handleInputChange(farmer.id, "quantity", e.target.value, farmer)
    //     }
    //   />
    // </div>

    // <div className="col-md-4">
    //   <label className="form-label">Unit</label>
    //   <select
    //     className="form-select"
    //     value={farmerInputs[farmer.id]?.unit_measurement || ""}
    //     onChange={(e) =>
    //       handleInputChange(farmer.id, "unit_measurement", e.target.value, farmer)
    //     }
    //   >
    //     <option value="">Select Unit</option>
    //     <option value="KG">KG</option>
    //     <option value="Quintal">Quintal</option>
    //     <option value="Metric Tonne">Metric Tonne</option>
    //   </select>
    // </div>

    // <div className="col-md-4">
    //   <label className="form-label">Price (₹)</label>
    //   <input
    //     type="number"
    //     className="form-control"
    //     value={farmerInputs[farmer.id]?.quoted_price || ""}
    //     onChange={(e) =>
    //       handleInputChange(farmer.id, "quoted_price", e.target.value, farmer)
    //     }
    //   />
    // </div>

    //               </div>
    //             </div>
    //           </div>
    //         ))}
    //       </div>
    //     </div>
    <div className="">
      {error && <div className="alert alert-danger mt-3">{error}</div>}

      <div className="text-end mb-3">
        <Button color="primary" size="sm" onClick={validateAndProceed}>
          Proceed
        </Button>
        <Button size="sm" onClick={handleBack}>
          Back
        </Button>
      </div>

      {activeFarmers.length === 0 ? (
        <div className="alert alert-info text-center">
          <h5>No Farmer Selected</h5>
          <p className="mt-2">
            Please go to <strong>Step 1</strong> and select farmers to continue.
          </p>
        </div>
      ) : (
        <div className="row">
          {activeFarmers.map((farmer) => (
            <div key={farmer.id} className="col-lg-6">
              <div className="border rounded p-3 mb-4 shadow position-relative">
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  size="lg"
                  className="position-absolute text-danger"
                  style={{ top: 12, right: 12, cursor: "pointer" }}
                  onClick={() => handleRemoveFarmer(farmer.id)}
                />
                <div className="d-flex align-items-start gap-3 mb-3">
                  <img
                    src={farmer.profile_pic}
                    alt="Farmer"
                    style={{ width: 60, height: 60, borderRadius: "50%" }}
                  />
                  <div>
                    <h6 className="mb-1">{farmer.full_name}</h6>
                    <p className="mb-0">
                      <strong>Gender:</strong> {farmer.gender}
                    </p>
                    <p className="mb-0">
                      <strong>Age:</strong> {farmer.age}
                    </p>
                    <p className="mb-0">
                      <strong>Address:</strong> {farmer.address},{" "}
                      {farmer.district_name || ""}, {farmer.state_name || ""} -{" "}
                      {farmer.pincode}
                    </p>
                  </div>
                </div>

                <div className="row g-2">
                  <div className="col-md-4">
                    <label className="form-label">Quantity</label>
                    <input
                      type="number"
                      className="form-control"
                      value={farmerInputs[farmer.id]?.quantity || ""}
                      onChange={(e) =>
                        handleInputChange(
                          farmer.id,
                          "quantity",
                          e.target.value,
                          farmer
                        )
                      }
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Unit</label>
                    <select
                      className="form-select"
                      value={farmerInputs[farmer.id]?.unit_measurement || ""}
                      onChange={(e) =>
                        handleInputChange(
                          farmer.id,
                          "unit_measurement",
                          e.target.value,
                          farmer
                        )
                      }
                    >
                      <option value="">Select Unit</option>
                      <option value="KG">KG</option>
                      <option value="Quintal">Quintal</option>
                      <option value="Metric Tonne">Metric Tonne</option>
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Price (₹)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={farmerInputs[farmer.id]?.quoted_price || ""}
                      onChange={(e) =>
                        handleInputChange(
                          farmer.id,
                          "quoted_price",
                          e.target.value,
                          farmer
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
